export default __webpack_public_path__ + "static/media/estatico.a08b268b.png";